import type { BlockProps, BlockType } from '../../types';

export function filterBlockProps(props: BlockProps) {
  if (areBlockPropsFilterable(props.type)) {
    return blockPropsFilters[props.type](props);
  }

  return props;
}

const blockPropsFilters = {
  button: filterButtonProps
} as const;

function areBlockPropsFilterable(
  type: BlockType
): type is keyof typeof blockPropsFilters {
  return type in blockPropsFilters;
}

function filterButtonProps(
  props: BlockProps & {
    buttonProps?: { size?: unknown; mobileSize?: unknown };
  }
) {
  const { buttonProps, ...rest } = props;
  const { size, mobileSize, ...filteredButtonProps } = buttonProps ?? {};

  return { ...rest, buttonProps: filteredButtonProps };
}
